import React from 'react';
import '../styles/Projects.css';

const ProjectCard = ({ title, date, description }) => {
    return (
        <div className="project-card">
            <div className="project-card-header">
                <h3 className="project-card-title">{title}</h3>
                {date && <span className="project-card-date">{date}</span>}
            </div>
            {description && <p className="project-card-description">{description}</p>}
        </div>
    );
}

export default ProjectCard;
